// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2V-DB","label":"Section_label__2D6Rq","contentWrap":"Section_contentWrap__2q59Z","footer":"Section_footer__3Ifmo","footerInner":"Section_footerInner__1ae6b"};